import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type AlexaApiErrorDescription = {
  title: string;
  detail: string;
  payload?: unknown;
};

const messagesByStatus: Record<number, string> = {
  400: 'The Alexa function request was malformed or is not allowlisted.',
  401: 'Your session is missing or has expired.',
  403: 'Alexa functions are restricted to Platform Admins.',
  404: 'The selected device no longer exists.',
  409: 'This function is unavailable because the device is missing required Alexa metadata.',
  500: 'The API could not complete the Alexa request.',
};

export const describeAlexaApiError = (
  error: FetchBaseQueryError | SerializedError,
): AlexaApiErrorDescription => {
  if ('status' in error) {
    if (typeof error.status === 'number') {
      return {
        title: `Request failed (${error.status})`,
        detail: messagesByStatus[error.status] ?? 'The request was rejected.',
        payload: error.data,
      };
    }

    return {
      title: 'Network error',
      detail: error.error ?? 'The request could not be completed.',
      payload: 'data' in error ? error.data : undefined,
    };
  }

  return {
    title: 'Unexpected error',
    detail: error.message ?? 'Something went wrong.',
  };
};
